import { ISODate } from '@frk/eds-components';
import { SiteConfigService } from '@services';
import { ConfigurationId, CurrencyCode } from '@types';
import { Logger } from '@utils/logger';
import { FundListingPerformanceController } from './fund-listing-performance.controller';
import { FundListingRatingsController } from './fund-listing-ratings.controller';
import { FundListingType } from './fund-listing.controller';

const logger = Logger.getLogger('FundListingCombinedController');

export class FundListingCombinedController
  extends FundListingPerformanceController
  implements FundListingRatingsController {
  public fundListingType: FundListingType = FundListingType.COMBINED;
  public hideRatingsToggle = true;
  public showCategory = true;
  public showViewDetails = true;
  public yieldToWorstAsOfDate?: string;

  constructor(
    protected siteConfig: SiteConfigService,
    public readonly productType: ConfigurationId,
    public componentName: string,
    // TODO: can as-of dates be optional?
    public readonly performanceAsOfDateMonthlyStd: ISODate,
    public readonly performanceAsOfDateQuarterlyStd: ISODate,
    public readonly performanceAsOfDateMonthly: string,
    public readonly performanceAsOfDateQuarterly: string,
    public readonly navAsOfDate: string, // null for SMAs
    public readonly stdYieldThirtyDayAsofDate: string,
    public readonly ratingsAsOfDate: string,
    public readonly performanceCurrencies?: CurrencyCode[] // only needed for South Africa. Come from data - not config
  ) {
    super(
      siteConfig,
      productType,
      componentName,
      performanceAsOfDateMonthlyStd,
      performanceAsOfDateQuarterlyStd,
      performanceAsOfDateMonthly,
      performanceAsOfDateQuarterly,
      navAsOfDate,
      performanceCurrencies
    );
    logger.debug(
      'constructor()',
      this.productType,
      this.componentName,
      this.performanceAsOfDateMonthlyStd,
      this.performanceAsOfDateQuarterlyStd,
      this.performanceAsOfDateMonthly,
      this.performanceAsOfDateQuarterly,
      this.navAsOfDate,
      this.stdYieldThirtyDayAsofDate,
      this.ratingsAsOfDate,
      this.performanceCurrencies
    );
  }
}

export const isFundListingCombinedController = (
  object: any
): object is FundListingCombinedController =>
  object.fundListingType === FundListingType.COMBINED;
